import React from 'react'

const StatsSection = ({ stats }) => {
  const items = [
    { label: 'Events Hosted', value: stats.totalEvents },
    { label: 'Happy Members', value: stats.totalMembers },
    { label: 'Active Groups', value: stats.totalGroups }
  ]

  return (
    <section className='stats-section'>
      <div className='landing-shell stats-section__grid'>
        {items.map((item) => (
          <div key={item.label} className='stats-card landing-reveal'>
            <div className='stats-card__value'>{item.value.toLocaleString()}</div>
            <div className='stats-card__label'>{item.label}</div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default StatsSection
